import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/es/storage";
// import storageSession from 'redux-persist/es/storage/session'
import { sessionReducer } from "./session-reducer";
import { settingsReducer } from "./settings-reducer";
import utilityReducer from "./utility-reducer";


export const rootReducer = combineReducers({
    session: sessionReducer,
    settings: settingsReducer,
    utility: utilityReducer,
});

const config = {
    key: 'root',
    storage
}

export const persistedRootReducer = persistReducer(config, rootReducer);